const formatpercent = function v(cellValue, precision) {
  if (cellValue === null || cellValue === undefined) {
    return cellValue;
  }
  return new Intl.NumberFormat(
    'pt-BR',
    {
      style: 'percent',
      minimumFractionDigits: precision,
    },
  )
    .format(cellValue * 0.01);
};

const formatcurrency = function v(cellValue, precision) {
  if (cellValue === null || cellValue === undefined) {
    return cellValue;
  }
  return new Intl.NumberFormat(
    'pt-BR',
    {
      style: 'currency',
      minimumFractionDigits: precision,
      currency: 'BRL',
    },
  )
    .format(cellValue);
};

const formatcpfcnpj = function v(cellValue) {
  if (cellValue !== null && cellValue !== undefined) {
    if (cellValue.length === 11) {
      return cellValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    }
    return cellValue.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }
  return cellValue;
};

const formatnumberdecimal = function v(cellValue) {
  return new Intl.NumberFormat('pt-BR').format(cellValue);
};

const formatphone = function v(cellValue) {
  if (cellValue !== null && cellValue !== undefined) {
    if (cellValue.length === 11) {
      if (cellValue.substring(0, 4) === '0800') {
        return cellValue.replace(/^(\d{4})(\d{3})(\d{4})$/, '$1 $2-$3');
      }
      return cellValue.replace(/(\d{2})(\d{5})(\d{4})/g, '($1) $2-$3');
    } if (cellValue.length === 10) {
      return cellValue.replace(/(\d{2})(\d{4})(\d{4})/g, '($1) $2-$3');
    }
    return cellValue.replace(/(\d{4})(\d{4})/g, '$1-$2');
  }
  return cellValue;
};

export {
  formatpercent, formatcurrency, formatcpfcnpj, formatnumberdecimal, formatphone,
};
